import { User } from '@auth0/auth0-react';
import { useLDClient } from '@mikecousins/launchdarkly-react-client-sdk';
import { useEffect } from 'react';

export const useLaunchDarkly = (user: User | undefined) => {
  const ldClient = useLDClient();

  useEffect(() => {
    if (user && ldClient) {
      ldClient.identify({
        key: user.sub,
        kind: 'user',
        custom: {
          name: user.name,
          email: user.email,
        },
      });
    }
  }, [ldClient, user]);

  return ldClient;
};
